export default "__VITE_ASSET__tIcQyl9o__"